import { FC, ReactNode } from 'react';
import styles from './Sidfot.module.css';
import { SidfotResponse } from '../../content/types/pages';
import ContentArea from '../../content/ContentArea';

interface ISidfotProps {
  sidfotResponse: SidfotResponse;
}

const Sidfot: FC<ISidfotProps> = ({
  sidfotResponse,
}): ReactNode => {
  return (
    <>
      {sidfotResponse.blockytan && (
        <footer className={styles.footer}>
          <div className={styles.footerColumns}>
            <ContentArea contentAreaResponse={sidfotResponse.blockytan} />
          </div>
        </footer>
      )}
    </>
  );
};

export default Sidfot;
